import { createFileRoute } from '@tanstack/react-router'

import VouchersPage from '@/views/loyalty/vouchers/pages/vouchers.page'

export const Route = createFileRoute('/_layout/loyalty/vouchers')({
  component: VouchersPage,
})
